// flags to determine how to handle
// showing a new result set
export const RESULTS_DISPLAY_REFRESH = 0;
export const RESULTS_DISPLAY_APPEND  = 1;
